module.exports = __webpack_public_path__ + "static/media/journalism.4ee6dad6.png";